import gql from 'graphql-tag';

export const GET_LIST_OF_PACCAR_CLASS_TYPES = gql`
  query GetListOfPacCarTypes {
    paccarClassTypes {
      name
      paccarCode
      type
    }
  }
`;
